import { ApiResponse } from "apisauce";
import { Api } from "../api/api";
import { IUser, IUserEmailCert } from '../../models';
import { IResponseSnapshot } from "src/models/response/Response";
import { TGeneralApiResponse } from "../api";

/**
* # User Api 서비스
* 
* 서비스의 설명을 작성하세요.
* 
* ## 사용방법
* 
* ```ts
* const service = new UserApi();
* 
* ```
*/
export class UserApi {
  private BASE_URL = '/user';

  private api: Api;

  constructor(api: Api) {
    this.api = api;
    this.api.setup();
  }

  /** 아이디 중복 체크 */
  async checkLoginIdDuplicate(loginId: string): Promise<TGeneralApiResponse> {
    try {
      const url = `${this.BASE_URL}/check/loginId/duplicate?loginId=${loginId}`;
      const response: ApiResponse<any> = await this.api.apisauce.get(url);
      const responseInfo: IResponseSnapshot = response.data;

      return { kind: 'ok', responseInfo: responseInfo };
    } catch (e) {
      return { kind: 'bad-data' };
    }
  }

  /** 회원가입 */
  async register(user: IUser): Promise<TGeneralApiResponse> {
    try {
      const url = `${this.BASE_URL}/register`;
      const response: ApiResponse<any> = await this.api.apisauce.post(url, user);
      const responseInfo: IResponseSnapshot = response.data;

      return { kind: 'ok', responseInfo: responseInfo };
    } catch (e) {
      return { kind: 'bad-data' };
    }
  }

  /** 로그인 */
  async login(user: IUser): Promise<TGeneralApiResponse> {
    try {
      const url = `${this.BASE_URL}/login`;

      const response: ApiResponse<any> = await this.api.apisauce.post(url, user);
      const responseInfo: IResponseSnapshot = response.data;

      return { kind: 'ok', responseInfo: responseInfo };
    } catch (e) {
      return { kind: 'bad-data' };
    }
  }

  /** 로그아웃 */
  async logout(): Promise<TGeneralApiResponse> {
    try {
      const url = `${this.BASE_URL}/logout`;
      const param = {
        refreshToken: sessionStorage.getItem('refreshToken')
      }
      const response: ApiResponse<any> = await this.api.apisauce.post(url, param);
      const responseInfo: IResponseSnapshot = response.data;

      return { kind: 'ok', responseInfo: responseInfo };
    } catch (e) {
      return { kind: 'bad-data' };
    }
  }

  /** 아이디 찾기 */
  async findLoginId(user: IUser): Promise<TGeneralApiResponse> {
    try {
      const url = `${this.BASE_URL}/find/loginId`;
      const response: ApiResponse<any> = await this.api.apisauce.post(url, user);
      const responseInfo: IResponseSnapshot = response.data;

      return { kind: 'ok', responseInfo: responseInfo };
    } catch (e) {
      return { kind: 'bad-data' };
    }
  }

  /** 비밀번호 재설정 - 계정 조회 */
  async resetPwdFindAccount(user: IUser): Promise<TGeneralApiResponse> {
    try {
      const url = `${this.BASE_URL}/reset/pwd/find/account`;
      const response: ApiResponse<any> = await this.api.apisauce.post(url, user);
      const responseInfo: IResponseSnapshot = response.data;

      return { kind: 'ok', responseInfo: responseInfo };
    } catch (e) {
      return { kind: 'bad-data' };
    }
  }

  /** 비밀번호 재설정 - 이메일 인증 */
  async resetPwdCertifyEmail(userEmailCert: IUserEmailCert): Promise<TGeneralApiResponse> {
    try {
      const url = `${this.BASE_URL}/reset/pwd/certify/email`;
      const response: ApiResponse<any> = await this.api.apisauce.post(url, userEmailCert);
      const responseInfo: IResponseSnapshot = response.data;

      return { kind: 'ok', responseInfo: responseInfo };
    } catch (e) {
      return { kind: 'bad-data' };
    }
  }

  /** 비밀번호 재설정 */
  async resetPwd(user: IUser): Promise<TGeneralApiResponse> {
    try {
      const url = `${this.BASE_URL}/reset/pwd`;
      const response: ApiResponse<any> = await this.api.apisauce.put(url, user);
      const responseInfo: IResponseSnapshot = response.data;

      return { kind: 'ok', responseInfo: responseInfo };
    } catch (e) {
      return { kind: 'bad-data' };
    }
  }

  /** 회원정보 조회 */
  async getProfile(): Promise<TGeneralApiResponse> {
    try {
      const url = `${this.BASE_URL}/profile`;
      const response: ApiResponse<any> = await this.api.apisauce.get(url);
      const responseInfo: IResponseSnapshot = response.data;

      return { kind: 'ok', responseInfo: responseInfo };
    } catch (e) {
      return { kind: 'bad-data' };
    }
  }

  /** 회원정보 수정 */
  async updateProfile(user: IUser): Promise<TGeneralApiResponse> {
    try {
      const url = `${this.BASE_URL}/profile`;
      const response: ApiResponse<any> = await this.api.apisauce.put(url, user);
      const responseInfo: IResponseSnapshot = response.data;

      return { kind: 'ok', responseInfo: responseInfo };
    } catch (e) {
      return { kind: 'bad-data' };
    }
  }

  /** 회원정보 수정 - 비밀번호 재설정 */
  async resetPwdByProfile(user: IUser): Promise<TGeneralApiResponse> {
    try {
      const url = `${this.BASE_URL}/profile/reset/pwd`;
      const response: ApiResponse<any> = await this.api.apisauce.put(url, user);
      const responseInfo: IResponseSnapshot = response.data;

      return { kind: 'ok', responseInfo: responseInfo };
    } catch (e) {
      return { kind: 'bad-data' };
    }
  }

  /** 회원탈퇴 */
  async withdrawal(): Promise<TGeneralApiResponse> {
    try {
      const url = `${this.BASE_URL}/withdrawal`;
      const param = {
        refreshToken: sessionStorage.getItem('refreshToken')
      }
      const response: ApiResponse<any> = await this.api.apisauce.put(url, param);
      const responseInfo: IResponseSnapshot = response.data;

      return { kind: 'ok', responseInfo: responseInfo };
    } catch (e) {
      return { kind: 'bad-data' };
    }
  }
}